'use client'

import { createContext } from 'react'

import type { HubVisit } from '@/lib/analytics/hub-visit'

export const HubVisitContext = createContext<HubVisit | null>(null)
